import { GcliRateGroup, RateGroup, TypeOfAgeRates } from "../../features/actuarial/rates-state";
import { RatesUpdateType } from "../../types/type";
import { updateGcliAmount } from "../../features/actuarial/rates-slice";
import { Dispatch } from "@reduxjs/toolkit";

export type AmountKind = "number" | "text";

export const getAmountKind = (value: string): AmountKind | null => {
    const trimmedValue = value.trim();

    if (!trimmedValue) return null;

    if (/^[+-]?(?:\d*\.?\d*)$/.test(trimmedValue)) return "number";

    return "text";
};


export const getRateAcronymFor6680 = (id: number, type: RatesUpdateType, rates: GcliRateGroup[]): string => {
    for (const group of rates) {
        const item = group.data.find(
            (item) => item.type === type && (type === "plan" ? item.plan_id === id : item.rider_id === id)
        );
        if (item) {
            return item.acronym || (type === "plan" ? "Plan" : "Rider");
        }
    }
    return type === "plan" ? "Plan" : "Rider";
};

export const getRateAcronym1865 = (id: number, type: RatesUpdateType, rates: RateGroup[]): string => {
    for (const group of rates) {
        const item = group.data.find(
            (item) =>
                item.type === type &&
                (type === 'plan' ? item.plan_id === id : item.rider_id === id)
        );
        if (item) return item.acronym || (type === 'plan' ? 'Plan' : 'Rider');
    }
    return type === 'plan' ? 'Plan' : 'Rider';
};


export const isAllowedTextPrefix = (value: string, allowed: string[]) => {
    const normalizedValue = value.trim().toUpperCase();
    return allowed.some((item) => item.startsWith(normalizedValue));
};

export const hasValidNumericFormat = (value: string): boolean => {
    return /^[+-]?(?:\d+|\d*\.\d{0,4})$/.test(value.trim());
};

export const isPlanComplete = (planId: number, rates: RateGroup[]) => {
    return rates.every((group) => {
        const plan = group.data.find(
            (item) => item.type === 'plan' && item.plan_id === planId
        );
        return plan !== undefined && typeof plan.amount === 'string' && plan.amount.trim() !== '';
    });
};

export const getMatchingItem = (groupTitle: string, id: number, type: RatesUpdateType, rates: GcliRateGroup[]) => {
    const group = rates.find((group) => group.title === groupTitle);

    return group?.data.find(
        (item) => item.type === type && (type === "plan" ? item.plan_id === id : item.rider_id === id)
    );
};

export const handleBulkFillSave = (
    dispatch: Dispatch<any>,
    typeOfAgeRates: TypeOfAgeRates,
    rates: GcliRateGroup[], 
    isAttainedAge: boolean, 
    setIsBulkFillOpen: (value: boolean)=> void,
    setBulkWarning: (value: string | null)=> void,
    setAmountWarning: (value: string | null)=> void,
    selectedMonths: string[],
    setSelectedMonths: (value: string[])=> void,
    bulkValue: string,
    setBulkValue: (value: string)=> void,
) => {

    if (isAttainedAge) return;
    if (selectedMonths.length === 0) {
        setBulkWarning("Please select at least one month.");
        return;
    }

    const trimmedValue = bulkValue.trim();
    const normalizedValue = trimmedValue.toUpperCase();
    const isAllowedString = ["N/A", "FREE"].includes(normalizedValue);
    const isValidNumber = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(trimmedValue);

    if (!trimmedValue || (!isAllowedString && !isValidNumber)) {
        setBulkWarning("Enter N/A, FREE, or a valid numeric value.");
        return;
    }

    const matchingItems = rates.flatMap((group) =>
        group.data
            .filter((item) => selectedMonths.includes(item.name || item.acronym))
            .flatMap((item) => {
                const id = item.type === "plan" ? item.plan_id : item.rider_id;
                if (id === null || id === undefined) return [];
                return [{ title: group.title, id, type: item.type }];
            })
    );

    if (matchingItems.length === 0) {
        setBulkWarning("No matching months with valid plan or rider IDs were found.");
        return;
    }

    matchingItems.forEach(({ title, id, type }) => {
        dispatch(updateGcliAmount({
            group: typeOfAgeRates,
            title,
            id,
            amount: isAllowedString ? normalizedValue : trimmedValue,
            type,
        }));
    });

    setIsBulkFillOpen(false);
    setSelectedMonths([]);
    setBulkValue("N/A");
    setBulkWarning(null);
    setAmountWarning(null);
};